import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DataQuality from "./pages/DataQuality";
import { ApiResponse } from "./types/dataQuality";

const queryClient = new QueryClient();

const DataQualityWidget = ({apiResponse}: {apiResponse: ApiResponse}) => (
    <QueryClientProvider client={queryClient}>
        <DataQuality apiResponse={apiResponse} />
    </QueryClientProvider>
);

export default DataQualityWidget;